// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* :root {
  --darModeColor: rgb(26 26 26);
  --primary: #EF0776;
  --activeSidebarButton:#f360a7;

}

.dark {
  background-color: var(--darModeColor);
  color: white;
} */

body {
  font-size: 13px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: transparent;
}

::-webkit-scrollbar:horizontal {
  width: 5px;
  height: 8px;
  background-color: transparent;
}

::-webkit-scrollbar:vertical {
  width: 8px;
  height: 5px;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(219, 219, 219);
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA;;;;;;;;;;GAUG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB","sourcesContent":["/* :root {\n  --darModeColor: rgb(26 26 26);\n  --primary: #EF0776;\n  --activeSidebarButton:#f360a7;\n\n}\n\n.dark {\n  background-color: var(--darModeColor);\n  color: white;\n} */\n\nbody {\n  font-size: 13px;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 5px;\n  background-color: transparent;\n}\n\n::-webkit-scrollbar:horizontal {\n  width: 5px;\n  height: 8px;\n  background-color: transparent;\n}\n\n::-webkit-scrollbar:vertical {\n  width: 8px;\n  height: 5px;\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: rgb(219, 219, 219);\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
